import { GET_ORDERS, FETCH_NEW_ORDER, WALLET_ORDERS_PAGINATE } from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'

const state = {
  paginate: {}
}

const getters = {
  [WALLET_ORDERS_PAGINATE]: 'paginate'
}

const mutations = {
  [WALLET_ORDERS_PAGINATE]: 'paginate'
}

const actions = {
  [GET_ORDERS]: async ({ commit }, payload) => {
    const response = await axios.get(`company/statement?${payload}`)
    commit(WALLET_ORDERS_PAGINATE, response.data.meta || {})

    return response.data.data
  },
  [FETCH_NEW_ORDER]: async ({ commit }, payload) => {
    const response = await axios.get(`company/statement?${payload}`)
    return response.data.data
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/wallet.js